import { InformationCircleIcon } from '@heroicons/react/20/solid';

export interface InfoAlertProps {
  text: string;
}

export const InfoAlert = (props: InfoAlertProps) => {
  return (
    <div className="rounded-md bg-info-subtle p-4">
      <div className="flex">
        <div className="shrink-0">
          <InformationCircleIcon aria-hidden="true" className="size-5 text-info" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-info">{props.text}</p>
        </div>
      </div>
    </div>
  );
};
